import { Button, Stack, Text, Title, useMantineTheme } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";
import { FormLayout } from "../common/FormLayout";

export const MailConfirmation = () => {
	const theme = useMantineTheme();

	const handleResendEmail = () => {
		alert("メールの再送信");
	};

	return (
		<FormLayout>
			<Stack gap={24}>
				<Stack align="center" justify="center">
					<IconMail size={56} stroke={1} color={theme.colors.primary[6]} />
				</Stack>
				<Title order={2} fw={400} style={{ textAlign: "center" }}>
					メールを確認してください
				</Title>
				<Text>
					パスワードのリセットに必要な手順の送信先
					<br />
					メールアドレス t.ashita@ashita.co.jpを確認
					<br />
					してください。
				</Text>
				<Button
					variant="outline"
					fullWidth
					size="md"
					onClick={handleResendEmail}
				>
					メールの再送信
				</Button>
			</Stack>
		</FormLayout>
	);
};
